<template>
  <div class="w-full overflow-hidden rounded-lg border border-[#f5f5f5] my-4 mx-0">
    <div @click="toggleCollapse" class="flex flex-col justify-between p-4 cursor-pointer
      bg-[#f5f5f5]">
      <div class="flex justify-between">
        <div class="break-all text-wrap">
          <h3 class="m-0">{{ item.name }}</h3>
          <p class="my-1 mx-0">{{ item.description }}</p>
        </div>
        <div>
          <span class="mr-3">
            {{ $t('SimilarKssItemComponent.users', { count: item.users.length }) }}
          </span>
          <font-awesome-icon :icon="isCollapsed ? 'angle-up' : 'angle-down'"/>
        </div>
      </div>
      <div class="flex justify-between items-end">
        <span>{{ getDate }}</span>
        <div class="flex items-center self-end">
          <img :src="getPicture" alt="" class="w-10 h-10 rounded-full ml-3 object-cover">
          <span class="ml-3">{{ item.creator && item.creator.name }}</span>
        </div>
      </div>
    </div>
    <div v-if="isCollapsed" class="bg-white p-4">
      <div v-for="(user, uIndex) in item.users" :key="uIndex"
        class="inline-block py-1 px-3 rounded-3xl text-sm bg-[var(--color-orange)] text-white
        mr-1 mb-1">
        {{ user.name }}
      </div>
    </div>
  </div>
</template>

<script>
import defaultProfileImage from '@/assets/defaultProfileImage.js';
import { formatLocaleDateTime } from '@/helpers/formatLocaleDate';

export default {
  name: 'SimilarKssItemComponent',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isCollapsed: false,
    };
  },
  computed: {
    getDate() {
      return formatLocaleDateTime(this.item.date);
    },
    getPicture() {
      if (this.item.creator?.picture_profile?.small) {
        return this.item.creator.picture_profile.small;
      }
      return defaultProfileImage;
    },
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
  },
};
</script>
